/**
* BaseService
**/
require("runners/localizationRunner");
require("runners/promiseRunner");
require("runners/serviceWorkerRunner");
require("runners/loadLoginRunner");
require("runners/messageNotificationsRunner");



// WEBPACK FOOTER //
// ./js/runners/runners.js